import { React, useState, useEffect } from "react";
import request from "../../../../Helpers/API";
import { Modal, TextField } from "@mui/material";
import Swal from "sweetalert2";
import PlantillaScreen from "../../../helpers/PlantillaScreen";
import RemoveCircleIcon from "@mui/icons-material/DeleteForever";
import AddCircleIcon from "@mui/icons-material/AddCircle"

export const AñadirPrecioMantenimientoModal = ({ open, onClose, id_paquete }) => {
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    const [precio, setPrecio] = useState({
        modelo: "",
        precio: "",
    });


    const formatWithCommas = (value) => {
        if (!value) return '';
        return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    };

    function removeCommas(value) {
        return value.replace(/,/g, '');
    }

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "precio") {
            const numericValue = value.replace(/[^0-9.]/g, "");
            setPrecio((prev) => ({ ...prev, [name]: formatWithCommas(numericValue) }));
        } else {
            setPrecio((prev) => ({ ...prev, [name]: value }));
        }
    };

    const onGuardar = () => {
        if (precio.modelo === undefined || precio.modelo === null || precio.modelo === "") {
            Swal.fire("Atención", "Debes capturar el modelo", "warning");
            return;
        }

        if (precio.precio === undefined || precio.precio === null || precio.precio === "") {
            Swal.fire("Atención", "Debes capturar el precio", "warning");
            return;
        }

        setLoader({ ...loader, mostrar: true });
        const post = {
            id_paquete: id_paquete,
            modelo: precio.modelo,
            precio: removeCommas(precio.precio)
        };
        request
            .post(`DashboardPostventa/AgregarPreciosMantenimiento`, post)
            .then(async (result) => {
                setLoader({ ...loader, mostrar: false });
                await Swal.fire({
                    title: "PAQUETE DE MANTENIMIENTO",
                    text: "Registro guardado con éxito",
                    icon: "success",
                    customClass: {
                        container: "mi-superpoop",
                    },
                });
                 onClose();
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("PAQUETE DE MANTENIMIENTO", JSON.stringify(error), "error");
            });
    };

    return (
        <>
            <Modal open={open} onClose={onClose}>
                <div className="paquetes-mantenimiento-modal-formulario">
                    <div className="paquetes-mantenimiento-modal-plantilla">
                        <div
                            className="plantilla-screen-filtro-container"
                            id="mdlFiltros-modal"
                        >
                            <PlantillaScreen
                                titulo={
                                    "AGREGAR PRECIO"
                                }
                                className_main={1}
                                className={"plantilla-screen-filtro-container-modal"}
                            >
                                <div className="cerrar-modal-button" onClick={onClose}>
                                    X
                                </div>

                                <div className="paquetes-mantenimiento-modal">
                                    <div className="paquetes-mantenimiento-listado-precios-modal">
                                        <TextField
                                            label="Modelo"
                                            name="modelo"
                                            value={precio.modelo}
                                            onChange={handleChange}
                                            fullWidth
                                        />
                                        <TextField
                                            label="Precio"
                                            name="precio"
                                            value={precio.precio}
                                            onChange={handleChange}
                                            fullWidth
                                        />
                                    </div>
                                    <div className="paquetes-mantenimiento-modal-buttons">
                                        <button
                                            className="paquetes-mantenimiento-modal-button-guardar"
                                            onClick={onGuardar}
                                        >
                                            Guardar
                                        </button>
                                    </div>
                                </div>
                            </PlantillaScreen>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
};
